// API 에러 응답 DTO 직접 정의 (OAISchema/openapi 금지 — api-typegen §0)
type OAIError = {
  code?: string;
  message?: string;
  userMessage?: string;
  traceId?: string;
  details?: unknown;
};

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly response: OAIError | unknown,
    public readonly url: string,
  ) {
    super(`HTTP Error ${status}: ${url}`);
    this.name = 'HttpError';
  }

  get userMessage(): string | undefined {
    if (HttpError.isOAIError(this.response)) {
      return this.response.userMessage;
    }
    return undefined;
  }

  get errorCode(): string | undefined {
    if (HttpError.isOAIError(this.response)) {
      return this.response.code;
    }
    return undefined;
  }

  private static isOAIError(response: unknown): response is OAIError {
    return (
      typeof response === 'object' &&
      response !== null &&
      ('code' in response || 'message' in response || 'userMessage' in response)
    );
  }
}
